import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import UiKit from './views/pages/UiKit.vue';
import OrderOverview from './views/pages/OrderOverview.vue';
import FormPage from "./views/pages/FormPage.vue";
import PickingV2 from "./views/pages/PickingV2.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/picking-v2',
        name: 'picking-v2',
        component: PickingV2,
        meta: {title: 'Picking'},
    },
    {
        path: '/picking-v2/:pickingId',
        name: 'picking-v2-active',
        component: PickingV2,
        meta: {title: 'Picking'},
    },
    {
        path: '/picking-v2/:pickingId/completed',
        name: 'picking-v2-completed',
        component: PickingV2,
        meta: {title: 'Picking opgeslagen'},
    },
    {
        path: '/ui-kit',
        component: UiKit,
        meta: {
            title: "UI kit",
        },
    },
    {
        path: '/form/:bundle/:definition/:objectId?/:relationString?',
        name: 'formPage',
        component: FormPage,
        meta: {
            title: "Form"
        },
    },
];

let routesAppended = Vue.cmsRouter.getRoutesAppend();
const gridRouteIndex = routesAppended.findIndex(route => route.name === 'grid' );

routesAppended.splice(gridRouteIndex, 0,
    {
        path: '/:gridDefinition/:sourceBundle/order-overview/:orderCode',
        name: 'order-overview',
        component: OrderOverview,
        meta: {
            title: "Order overview",
        },
        children: [
            {
                path: ':bundle/:definition/:objectId/:relationString?',
                name: 'order-overview-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    })

routes = [...Vue.cmsRouter.getRoutesPrepend(), ...routes, ...routesAppended];

// Change home dashboard
const homeRouteKey = routes.findIndex(route => route.path === '/');
routes[homeRouteKey] = {
    path: '/',
    component: Dashboard,
    meta: {
        title: "dashboard",
    },
    alias: '/home'
}

const router = new VueRouter({
    routes
});

Vue.cmsRouter.setActiveRouter(router);

export default router;
